/**
 * An enum distinguishing whether the leaf nodes in a group should be copied individually or as a grouped subtree.
 */
export enum AnalyseShowAllBulkAdditionType {
  INDIVIDUAL = 'Individual Leaf Nodes. Groups, if any will be flattened (removed from the addition) to only include their leaf nodes.',
  GROUPED = 'Add as a subtree with nested groups',
}
